import { deleteAPI, getAPI, patchAPI, postAPI, putAPI } from "../utils/api";
import endPoints from "../utils/endPoints";

export const register = (payload, callBack, errorCallback) => {
    return (dispatch) => {
        postAPI(
            endPoints?.REGISTER,
            payload,
            (response) => {
                callBack(response);
            },
            (error) => {
                errorCallback(error);
            },
        );
    };
}

export const verifyPhoneOTP = (payload, callBack, errorCallback, manualToken) => {
    return (dispatch) => {
        postAPI(
            endPoints.VERIFY_PHONE_OTP,
            payload,
            (response) => {
                callBack(response);
            },
            (error) => {
                errorCallback(error);
            },
            manualToken
        );
    };
};

export const phoneOTPToForgotPassword = (payload, callBack, errorCallback) => {
    return (dispatch) => {
        postAPI(
            endPoints.PHONE_OTP_TO_FORGOT_PASSWORD,
            payload,
            (response) => {
                callBack(response);
            },
            (error) => {
                errorCallback(error);
            },
        );
    };
};

export const verifyPhoneOTPToForgotPassword = (payload, callBack, errorCallback, manualToken) => {
    return (dispatch) => {
        postAPI(
            endPoints.VERIFY_PHONE_OTP_TO_FORGOT_PASSWORD,
            payload,
            (response) => {
                callBack(response);
            },
            (error) => {
                console.log('Error While Verifying Phone OTP to Forgot Password', error);
                errorCallback(error);
            },
            manualToken
        );
    };
};

export const verifyEmailOTP = (payload, callBack, errorCallback, manualToken) => {
    return (dispatch) => {
        postAPI(
            endPoints.VERIFY_EMAIL_OTP,
            payload,
            (response) => {
                callBack(response);
            },
            (error) => {
                errorCallback(error);
            },
            manualToken
        );
    };
};

export const emailOTPToForgotPassword = (payload, callBack, errorCallback) => {
    return (dispatch) => {
        postAPI(
            endPoints.EMAIL_OTP_TO_FORGOT_PASSWORD,
            payload,
            (response) => {
                callBack(response);
            },
            (error) => {
                errorCallback(error)
            },
        );
    };
};

export const verifyEmailOTPForForgotPassword = (payload, callBack, errorCallback, manualToken) => {
    return (dispatch) => {
        postAPI(
            endPoints.VERIFY_EMAIL_OTP_FORGOT_PASSWORD,
            payload,
            (response) => {
                console.log('Response For Verifying Email OTP for Forgot Password', response);
                callBack(response);
            },
            (error) => {
                console.log('Error While Verifying Email OTP for Forgot Password', error);
                errorCallback(error)
            },
            manualToken
        );
    };
};

export const activation = (payload, callBack) => {
    return (dispatch) => {
        postAPI(
            endPoints.ACTIVATION,
            payload,
            (response) => {
                console.log('Response For Activation', response);
                callBack(response);
            },
            (error) => {
                console.log('Error While Activation', error);
            },
        );
    };
};

export const login = (payload, callBack, errorCallback) => {
    return (dispatch) => {
        postAPI(
            endPoints.LOGIN,
            payload,
            (response) => {
                console.log('Response For Login', response);
                callBack(response);
            },
            (error) => {
                console.log('Error While Login', error);
                errorCallback(error)
            },
        );
    };
};

export const refreshToken = (payload, callBack) => {
    return (dispatch) => {
        postAPI(
            endPoints.REFERESH_TOKEN,
            payload,
            (response) => {
                console.log('Response For Refresh Token', response);
                callBack(response);
            },
            (error) => {
                console.log('Error While Refreshing Token', error);
            },
        );
    };
};

export const forgotPassword = (payload, callBack) => {
    return (dispatch) => {
        postAPI(
            endPoints.FORGOT_PASSWORD,
            payload,
            (response) => {
                console.log('Response For Forgot Password', response);
                callBack(response);
            },
            (error) => {
                console.log('Error While Forgot Password', error);
            },
        );
    };
};

export const reset = (payload, callBack, errorCallback, manualToken) => {
    return (dispatch) => {
        postAPI(
            endPoints.RESET,
            payload,
            (response) => {
                callBack(response);
            },
            (error) => {
                errorCallback(error);
            },
            manualToken
        );
    };
};

export const getUserInformation = (payload, callBack, errorCallback, manualToken) => {
    return (dispatch) => {
        getAPI(
            endPoints.GET_USER_INFROMATION,
            payload,
            (response) => {
                console.log('Response For Getting User Information', response);
                callBack(response);
            },
            (error) => {
                console.log('Error While Getting User Information', error);
            },
            manualToken
        );
    };
};

export const getAllUsers = (payload, callBack) => {
    return (dispatch) => {
        getAPI(
            endPoints.GET_ALL_USERS,
            payload,
            (response) => {
                console.log('Response For Getting All Users', response);
                callBack(response);
            },
            (error) => {
                console.log('Error While Getting All Users', error);
            },
        );
    };
};

export const logout = (payload, callBack) => {
    return (dispatch) => {
        postAPI(
            endPoints.LOGOUT,
            payload,
            (response) => {
                console.log('Response For Logout', response);
                callBack(response);
            },
            (error) => {
                console.log('Error While Logout', error);
            },
        );
    };
};

export const updateUser = (payload, callBack) => {
    return (dispatch) => {
        patchAPI(
            endPoints.UPDATE_USER,
            payload,
            (response) => {
                console.log('Response For Updating User', response);
                callBack(response);
            },
            (error) => {
                console.log('Error While Updating User', error);
            },
        );
    };
};

export const updateRole = (payload, callBack) => {
    return (dispatch) => {
        patchAPI(
            endPoints.UPDATE_ROLE,
            payload,
            (response) => {
                console.log('Response For Updating Role', response);
                callBack(response);
            },
            (error) => {
                console.log('Error While Updating Role', error);
            },
        );
    };
};

export const deleteUser = (payload, callBack) => {
    return (dispatch) => {
        deleteAPI(
            endPoints.DELETE_USER,
            payload,
            (response) => {
                console.log('Response For Deleting User', response);
                callBack(response);
            },
            (error) => {
                console.log('Error While Deleting User', error);
            },
        );
    };
};

export const createProfile = (payload, ID, params, callback, errorCallback, manualToken) => {
    return (dispatch) => {
        putAPI(
            endPoints.CREATE_PROFILE.replace("{0}", params).replace("{1}", ID),
            payload,
            (response) => {
                callback(response);
            },
            (error) => {
                errorCallback(error);
            },
            manualToken
        );
    };
}

export const createJobDraft = (payload, callBack) => {
    return (dispatch) => {
        postAPI(
            endPoints.CREATE_JOB_DRAFT,
            payload,
            (response) => {
                console.log('Response For Job Creation', response);
                callBack(response);
            },
            (error) => {
                console.log('Error While Creating job', error);
            },
        );
    };
};
export const createJob = (payload, callBack, errorCallback) => {
    return (dispatch) => {
        postAPI(
            endPoints.CREATE_JOBS,
            payload,
            (response) => {
                console.log('Response For create job', response);
                callBack(response);
            },
            (error) => {
                console.log('Error While create job', error);
                errorCallback(error);
            },
        );
    };
};

export const updateJob = (id, payload, callback, errorCallback) => {
    return (dispatch) => {
        putAPI(
            endPoints.UPDATE_JOB + "/" + id,
            payload,
            (response) => {
                callback(response);
            },
            (error) => {
                errorCallback(error);
            }
        );
    };
}

export const getJobById = (payload, callBack) => {
    return (dispatch) => {
        getAPI(
            endPoints.GET_JOB + "/" + payload.id,
            {},
            (response) => {
                console.log('Response For Getting Get Jobs', response);
                callBack(response);
            },
            (error) => {
                console.log('Error While Getting Get Jobs', error);
            },
        );
    };
};

export const deleteJobById = (id, payload, callBack, errorCallback) => {
    return (dispatch) => {
        deleteAPI(
            endPoints.GET_JOB + "/" + id,
            payload,
            (response) => {
                callBack(response);
            },
            (error) => {
                console.log('Error while delete jobs', error);
                errorCallback(error);
            },
        );
    };
};

export const getAllJobs = (payload, callBack) => {
    return (dispatch) => {
        getAPI(
            endPoints.CREATE_JOBS,
            {},
            (response) => {
                console.log('Response for get all jobs', response);
                callBack(response);
            },
            (error) => {
                console.log('Error for get all jobs', error);
            },
        );
    };
}

export const getAllSimiliarJobs = (id, callBack) => {
    return (dispatch) => {
        getAPI(
            endPoints.SIMILIAR_JOBS + '/' + id,
            {},
            (response) => {
                console.log('Response for get all jobs', response);
                callBack(response);
            },
            (error) => {
                console.log('Error for get all jobs', error);
            },
        );
    };
}

export const searchJob = (payload, callBack) => {
    return (dispatch) => {
        getAPI(
            endPoints.SEARCH_JOB,
            payload,
            (response) => {
                console.log('Response for get all jobs', response);
                callBack(response);
            },
            (error) => {
                console.log('Error for get all jobs', error);
            },
        );
    };
}

export const createAvailability = (payload, callBack) => {
    return (dispatch) => {
        postAPI(
            endPoints.CREATE_AVAILABILITY,
            payload,
            (response) => {
                console.log('Response for create availability', response);
                callBack(response);
            },
            (error) => {
                console.log('Error for create availability', error);
            },
        );
    };
}

export const getAvailabilityById = (payload, callBack) => {
    return (dispatch) => {
        getAPI(
            endPoints.GET_AVAILABILITY_BY_ID + '/' + payload.id,
            {},
            (response) => {
                console.log('Response for get availability', response);
                callBack(response);
            },
            (error) => {
                console.log('Error for get availability', error);
            },
        );
    }
}

export const updateAvailabilityById = (payload, callBack) => {
    return (dispatch) => {
        putAPI(
            endPoints.UPDATE_AVAILABILITY,
            payload,
            (response) => {
                console.log('Response for update availability', response);
                callBack(response);
            },
            (error) => {
                console.log('Error for update availability', error);
            },
        );
    };
}

export const getAvailabilityDocumentById = (payload, callBack) => {
    return (dispatch) => {
        getAPI(
            endPoints.GET_AVAILABILITY_DOCUMENT + '/' + payload.id,
            {},
            (response) => {
                console.log('Response for get availability', response);
                callBack(response);
            },
            (error) => {
                console.log('Error for get availability', error);
            },
        );
    }
}

export const applyForJob = (payload, callBack, errorCallback) => {
    return (dispatch) => {
        postAPI(
            endPoints.APPLY_JOB,
            payload,
            (response) => {
                console.log('Response for get availability', response);
                callBack(response);
            },
            (error) => {
                console.log('Error for get availability', error);
            },
        );
    }
}
export const getServiceById = (payload, callBack) => {
    return (dispatch) => {
        getAPI(
            endPoints.GET_SERVICE_BY_ID + '/' + payload.id,
            {},
            (response) => {
                console.log('Response for get service by id', response);
                callBack(response);
            },
            (error) => {
                console.log('Error for get get service by id', error);
            },
        );
    }
}
export const getAppliedJobs = (payload, callBack) => {
    return (dispatch) => {
        getAPI(
            endPoints.GET_APPLIED_JOBS + '/' + payload.id,
            {},
            (response) => {
                console.log('Response for get service by id', response);
                callBack(response);
            },
            (error) => {
                console.log('Error for get get service by id', error);
            },
        );
    }
}

export const getAllService = (payload, callBack) => {
    return (dispatch) => {
        getAPI(
            endPoints.GET_ALL_SERVICES,
            {},
            (response) => {
                console.log('Response for get services', response);
                callBack(response);
            },
            (error) => {
                console.log('Error for get serices', error);
            },
        );
    }
}

export const updateServiceById = (id, payload, callBack, errorCallback) => {
    return (dispatch) => {
        putAPI(
            endPoints.UPDATE_SERVICE + '/' + id,
            payload,
            (response) => {
                console.log('Response for update service', response);
                callBack(response);
            },
            (error) => {
                console.log('Error for update service', error);
                errorCallback(error);
            },
        );
    };
}

export const createService = (payload, callBack, errorCallback) => {
    return (dispatch) => {
        postAPI(
            endPoints.ADD_SERVICE,
            payload,
            (response) => {
                console.log('Response for create service', response);
                callBack(response);
            },
            (error) => {
                console.log('Error for create service', error);
                errorCallback(error);
            },
        );
    };
}

export const deleteServiceById = (id, payload, callBack, errorCallback) => {
    return (dispatch) => {
        deleteAPI(
            endPoints.DELETE_SERVICE + "/" + id,
            payload,
            (response) => {
                callBack(response);
            },
            (error) => {
                console.log('Error while delete service', error);
                errorCallback(error);
            },
        );
    };
};

export const getCoachService = (payload, callBack) => {
    return (dispatch) => {
        getAPI(
            endPoints.GET_COACH_SERVICES + '/' + payload.id,
            {},
            (response) => {
                console.log('Response for get services by coach id', response);
                callBack(response);
            },
            (error) => {
                console.log('Error for get services by coach id', error);
            },
        );
    }
}

export const getUsersByProfile = (payload, callBack) => {
    return (dispatch) => {
        getAPI(
            endPoints.GET_PROFILES,
            payload,
            (response) => {
                console.log('Response for get services by coach id', response);
                callBack(response);
            },
            (error) => {
                console.log('Error for get services by coach id', error);
            },
        );
    }
}

export const uploadImages = (payload, callBack, errorCallback) => {
    return (dispatch) => {
        postAPI(
            endPoints.UPLOAD_IMAGE,
            payload,
            (response) => {
                console.log('Response for get services by coach id', response);
                callBack(response);
            },
            (error) => {
                console.log('Error for get services by coach id', error);
                errorCallback(error);
            },
        );
    }
}

export const linkedInLogin = (payload, callBack) => {
    return () => {
        getAPI(
            endPoints.LinkIn_Login,
            payload,
            (response) => {
                console.log('Response for get services by coach id', response);
                callBack(response);
            },
            (error) => {
                console.log('Error for get services by coach id', error);
            },
        );
    };
}

export const getUserInfoById = (payload, callBack) => {
    return (dispatch) => {
        getAPI(
            endPoints.GET_USER_INFO_BY_ID + "/" + payload.id,
            {},
            (response) => {
                console.log('Response For Getting Get info', response);
                callBack(response);
            },
            (error) => {
                console.log('Error While Getting Get info', error);
            },
        );
    };
};

export const getCoachServicesByID = (payload, callBack) => {
    return (dispatch) => {
        getAPI(
            endPoints.GET_COACH_SERVICES + "/" + payload.id,
            {},
            (response) => {
                console.log('Response For Getting Get info', response);
                callBack(response);
            },
            (error) => {
                console.log('Error While Getting Get info', error);
            },
        );
    };
};

export const googleLogin = (payload, callBack, errorCallback) => {
    return () => {
        postAPI(
            endPoints.Google_Login,
            payload,
            (response) => {
                console.log('Response for google login', response);
                callBack(response);
            },
            (error) => {
                console.log('Error for google login', error);
                errorCallback(error);
            },
        );
    };
}

